import { Component, OnInit, computed, inject, input, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { FormsModule } from '@angular/forms'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { ComparisonService } from 'src/app/core/services/comparison.service'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'

@Component({
  selector: 'app-comparison-toggle',
  template: `
    <div
      class="ComparisonToggle"
      [class.with-bg]="theme() === 'with-bg'"
      [class.no-bg]="theme() === 'no-bg'"
      [class.theme-checkbox]="theme() === 'no-bg'"
      data-testid="comparison-toggle"
      (click)="$event.stopPropagation()"
    >
      <mat-checkbox
        [checked]="checked()"
        (click)="toggle()"
        [disabled]="disabled()"
      >
        {{ compareText }}
      </mat-checkbox>
    </div>
  `,
  styleUrls: ['./comparison-toggle.component.scss'],
  imports: [CommonModule, FormsModule, MatCheckboxModule]
})
export class ComparisonToggleComponent implements OnInit {
  private _comparisonService = inject(ComparisonService)
  compareText = $localize`:@@comparison-toggle.label:Compare`

  checked = signal(false)
  asset = input.required<IAsset>()
  theme = input<'with-bg' | 'no-bg'>('no-bg')

  disabled = computed(() => this._comparisonService.assetsAreFull() && !this._comparisonService.checkAssetBeingCompared(this.asset()))
  isBeingCompared = computed(() => this._comparisonService.assets().some(asset => asset.equipment_number === this.asset()?.equipment_number))

  constructor() {
    toObservable(this._comparisonService.assets).pipe(
      takeUntilDestroyed(),
    ).subscribe(() => {
      this.init()
    })
    toObservable(this.asset).pipe(
      takeUntilDestroyed(),
    ).subscribe(() => {
      this.init()
    })
  }

  ngOnInit(): void {
    this.init()
  }

  init() {
    this.setToggleState()
  }

  setToggleState() {
    if (this._comparisonService.checkAssetBeingCompared(this.asset())) {
      this.checked.set(true)
    } else {
      this.checked.set(false)
    }
  }

  toggle() {
    const newCheckedState = !this.checked()
    this.checked.set(newCheckedState)

    if (newCheckedState) {
      this._comparisonService.addAsset(this.asset())
    } else {
      this._comparisonService.removeAsset(this.asset()?.equipment_number)
    }
  }
}
